import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Sidebar } from "arui-feather/sidebar";
import Schemas from "schemas";
import styled from "styled-components";

import { Control } from "components/ui-kit/control";
import { AuthStyles, Button, Frame, Logo } from "components/ui-kit/styled-templates";

import UserApi from "api/user-api";

import useFormControl from "hooks/useFormControl";

import { EForms } from "types/enums";

const LoginPage = () => {
    const { t } = useTranslation();

    const { onSubmit } = useFormControl({ name: EForms.login, schema: Schemas.login });
    const [recoverVisible, setRecoverVisible] = useState(false);
    const [recovering, setRecovering] = useState(false);
    const [recEmail, setRecEmail] = useState("");
    const [recoverySent, setRecoverySent] = useState(false);
    const handlers = {
        submit: UserApi.login,
    };
    return (
        <Frame extra={`min-height: inherit; width: inherit;`}>
            <AuthStyles.Container>
                <Link to="/">
                    <Logo className={"logo"} />
                </Link>
                <h2 style={{marginBottom: '15px', marginTop: '15px'}} >{t("kpne6ilu34j")}</h2>
                <Control.Form name={EForms.login} onSubmit={onSubmit(handlers.submit)}>
                    <Control.Input name="email" label={t("olxpylq49rh")} placeholder={t("c0ave1fs9m4")} />
                    <Control.Password name="password" label={t("ifh749h3w4f")} placeholder={t("yeq3i8ieewg")} />
                    <Button type="submit" background="blue" extra={`width: 100%; padding: `}>
                        {t("ysjmkxmw9x8")}
                    </Button>
                    <PolicyWrapper>
                        {t("vjk9gn25adj")}
                        <br />
                        <PolicyLink href={"/studpolicy.pdf"}>{t("tw8zxrngef")}</PolicyLink>
                    </PolicyWrapper>
                    <AuthStyles.LinksWrapper>
                        <Link to="/registration/student">{t("zerbb9epiei")}</Link>
                        {/* <Link to="/registration/university">Регистрация для образовательных организаций</Link> */}
                    </AuthStyles.LinksWrapper>
                </Control.Form>
            </AuthStyles.Container>

            <ForgotPasswordPlaceholder>
                <ForgotSpan
                    onClick={() => {
                        setRecoverVisible(true);
                    }}
                >
                    {t("yl2g4e7hhfp")}
                </ForgotSpan>
            </ForgotPasswordPlaceholder>

            <Sidebar
                visible={recoverVisible}
                onCloserClick={() => {
                    setRecoverVisible(false);
                }}
            >
                {recoverVisible == false ? null : (
                    <div>
                        <h2>{t("u9e6rn66ltm")}</h2>
                        {recoverySent == true ? (
                            <p>{`Инструкции по восстановлению пароля отправлены на почту ${recEmail}`}</p>
                        ) : (
                            <>
                                <Control.Input
                                    name="email"
                                    value={recEmail}
                                    label={t("dnx9wuzqgae")}
                                    placeholder={t("bahq5t7ox3i")}
                                    onChange={(evt) => {
                                        setRecEmail(evt.target.value);
                                    }}
                                />
                                <Button
                                    background="blue"
                                    extra={`width: 100%; padding: `}
                                    onClick={async () => {
                                        setRecovering(true);
                                        await UserApi.createPasswordRecoveryIntent(recEmail);
                                        setRecovering(false);
                                        setRecoverySent(true);
                                    }}
                                >
                                    {t("9t5haxp58p")}
                                </Button>
                            </>
                        )}
                    </div>
                )}
            </Sidebar>
        </Frame>
    );
};

const ForgotPasswordPlaceholder = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px;
`;

const ForgotSpan = styled.div`
    font-size: 12px;
    opacity: 0.5;
    cursor: pointer;

    :hover {
        opacity: 1;
    }
`;

const PolicyWrapper = styled.div`
    font-size: 10px;
    opacity: 0.7;
    text-align: center;
    padding: 7px;
`;

const PolicyLink = styled.a`
    text-decoration: underline;
    opacity: 0.5;

    :hover {
        opacity: 1;
    }
`;

export default LoginPage;
